module.exports = __webpack_public_path__ + "static/media/less.6942348d.svg";